import checkout from './checkout';
import aaCheckout from './aa-checkout';

export default {
  flights: {
    ...checkout,
    ...aaCheckout,
  },
};
